import type { RuntimeConfig } from '../auth/oauth';
import { microsoftLogoutUrl } from '../auth/session';

/**
 * The shared-workstation warning.
 *
 * Local sign-out drops this app's tokens and revokes the refresh token, but it cannot clear
 * Cognito's session cookie on the broker domain or the Microsoft session — so a new console session
 * is still obtainable here without a password prompt. Saying so plainly is the honest option;
 * claiming "you have been signed out" would not be true.
 */
export function SignedOut({ config }: { config: RuntimeConfig }) {
  return (
    <div className="centered">
      <h1>Signed out of this console</h1>
      <p>Your tokens have been discarded and the refresh token revoked.</p>

      <div className="callout callout-warn">
        <strong>Your Microsoft session is still active.</strong> This did not sign you out of
        Microsoft, and this browser can still get a new console session without a password prompt
        until that session expires.
        <p>
          On a shared workstation,{' '}
          <a href={microsoftLogoutUrl(config)} rel="noreferrer">
            also sign out of Microsoft
          </a>
          .
        </p>
      </div>

      <p>
        <a href="/">Sign back in</a>
      </p>
    </div>
  );
}
